import React, { useState } from 'react';
import { Field, FieldArray } from 'redux-form';
import Loader from '../../../../common/components/Loader/Loader';
import { Col, ControlLabel, FormGroup, Row } from 'react-bootstrap';
import startCase from '../../../../helpers/socratesLodash/startCase';
import TextArea from '../../../content/components/TextArea/TextArea';
import {
  HorizontalFormControl,
  Button,
  PublicCheckbox,
} from '../../../../common/components';
import styled from 'styled-components';
import MdRemoveCircleOutline from 'react-icons/lib/md/remove-circle-outline';
import MdControlPoint from 'react-icons/lib/md/control-point';
import MdDeleteForever from 'react-icons/lib/md/delete-forever';
import { FormGroupInput } from '../../../../common/form/components/components';
import {
  WhiteLabelContentContainer
} from '../WLContentContainer/WhiteLabelContentContainer';

const SubSection = styled.div`
  border: 1px darkgrey solid;
  border-radius: 4px;
  padding: 20px;
  background: #efefef;

  .RichEditor-root {
    background-color: white;
  }
`;

const More = styled(MdControlPoint)`
  float: right;
  color: #21174F;
`;
const Less = styled(MdRemoveCircleOutline)`
  float: right;
  color: #21174F;
`;

const Delete = styled(MdDeleteForever)`
  float: left;
  margin-right: 10px;
`;

const SectionTitle = styled.div`
  font-size: 23px;
  color: #21174F;
  justify-content: center;
  flex-grow: 1;
  display: flex;
`;

const QuestionTitle = styled.div`
  font-size: 16px;
  flex-grow: 1;
  display: flex;
`;
const QuestionSectionTitle = styled.div`
  display: flex;
  justify-content: space-between;
`;

const QuestionAndAnswerSection = styled.div`
  border: 1px darkgrey solid;
  border-radius: 4px;
  padding: 20px;
  background: #efefef;
  margin-bottom: 20px;
`;

const StyledQuestionSection = styled.div`
  border-bottom: 1px solid red;
  padding-bottom: 20px;
  margin-bottom: 20px;
`;

const QuestionSectionHeader = ({ input }) => <SectionTitle>{input.value}</SectionTitle>;

const QuestionHeader = ({ input }) => <QuestionTitle>{input.value}</QuestionTitle>;

const Remove = ({ index, onRemove, isDisabled }) => {
  if (isDisabled) {
    return null;
  }

  const remove = () => {
    onRemove(index);
  };
  return <Delete onClick={remove} size={20} />;
};
const QuestionAndAnswer = ({ fields, isDisabled }) => {
  const [showQuestionAndAnswer, toggleShowQuestionAndAnswer] = useState('');

  const add = () => {
    fields.push();
  };
  const remove = (index) => {
    fields.remove(index);
  };
  return (
    <>
      {fields.map((fieldName, index) => {
        return (
          <QuestionAndAnswerSection key={index}>
            <FormGroup>
              <Col sm={12}>
                <Remove index={index} onRemove={remove} isDisabled={isDisabled} />
                <QuestionSectionTitle>
                  <Field name={`${fieldName}.question`} component={QuestionHeader} />
                  {showQuestionAndAnswer === fieldName ? (
                    <Less size={30} onClick={() => toggleShowQuestionAndAnswer('')} />
                  ) : (
                    <More
                      size={30}
                      onClick={() => toggleShowQuestionAndAnswer(fieldName)}
                    />
                  )}
                </QuestionSectionTitle>
              </Col>
            </FormGroup>
            {showQuestionAndAnswer === fieldName && (
              <>
                <ControlLabel>Question</ControlLabel>
                <Field
                  name={`${fieldName}.question`}
                  component={TextArea}
                  readOnly={isDisabled}
                />
                <ControlLabel>Answer</ControlLabel>
                <Field
                  name={`${fieldName}.answer`}
                  component={TextArea}
                  readOnly={isDisabled}
                />
              </>
            )}
          </QuestionAndAnswerSection>
        );
      })}
      {!isDisabled && (
        <FormGroup>
          <Col sm={12}>
            <Button handleClick={add} bsStyle={'primary'} className={'pull-right'}>
              Add
            </Button>
          </Col>
        </FormGroup>
      )}
    </>
  );
};

const QuestionField = ({ show, isDisabled, fieldName, index, onRemove, onToggle }) => {
  const remove = (rmIndex) => {
    onRemove(rmIndex);
  };
  const less = () => {
    onToggle('');
  };
  const more = () => {
    onToggle(fieldName);
  };
  return (
    <StyledQuestionSection>
      <FormGroup>
        <Col sm={12}>
          <Remove onRemove={remove} index={index} isDisabled={isDisabled} />
          <QuestionSectionTitle>
            <Field
              name={`${fieldName}.header`}
              component={QuestionSectionHeader}
              key={index}
            />
            {show ? <Less size={30} onClick={less} /> : <More size={30} onClick={more} />}
          </QuestionSectionTitle>
        </Col>
      </FormGroup>
      {show && (
        <SubSection>
          <Field
            name={`${fieldName}.header`}
            component={HorizontalFormControl}
            disabled={isDisabled}
            label={'Section Header'}
          />

          <FieldArray
            name={`${fieldName}.questions_and_answers`}
            component={QuestionAndAnswer}
            isDisabled={isDisabled}
          />
        </SubSection>
      )}
    </StyledQuestionSection>
  );
};

const QuestionSection = ({ fields, isDisabled }) => {
  const [showSection, toggleShowSection] = useState('');

  const remove = (index) => {
    fields.remove(index);
  };

  const add = () => {
    fields.push();
  };

  return (
    <>
      {fields.map((fieldName, index) => {
        return (
          <QuestionField
            key={fieldName}
            index={index}
            show={showSection === fieldName}
            fieldName={fieldName}
            isDisabled={isDisabled}
            onRemove={remove}
            onToggle={toggleShowSection}
          />
        );
      })}
      {!isDisabled && (
        <Button handleClick={add} bsStyle={'primary'} className={'pull-right'}>
          Add
        </Button>
      )}
    </>
  );
};

export const Questions = ({ input, disabled }) => {
  return (
    <>
      <FieldArray name={input.name} component={QuestionSection} isDisabled={disabled} />
    </>
  );
};

const ComponentMap = {
  textarea: TextArea,
  text: FormGroupInput,
  textarea_array: Questions,
};
export const FaqSections = ({ template, input, isDisabled }) => {
  return (
    <>
      {Object.keys(template.data.attributes.sections).map((templateSectionKey) => {
        //loop through top level sections
        const fieldtype = template.data.attributes.sections[templateSectionKey].fieldtype;
        return (
          <div key={templateSectionKey}>
            <Row>
              <Col sm={12}>
                <Field
                  key={templateSectionKey}
                  name={`${input.name}.${templateSectionKey}`}
                  type={templateSectionKey}
                  label={startCase(templateSectionKey)}
                  labelSize={2}
                  colSize={12}
                  component={ComponentMap[fieldtype]}
                  disabled={isDisabled}
                  readOnly={isDisabled}
                />
              </Col>
            </Row>
          </div>
        );
      })}
    </>
  );
};

const ContentFields = ({ isEnabled, template }) => {
  if (!template) {
    return <Loader />;
  }

  return (
    <Field
      name={'meta.faq.content.attributes.sections'}
      template={template}
      component={FaqSections}
      isDisabled={!isEnabled}
    />
  );
};
export const Faqs = ({ template, isEnabled }) => {

  return (
      <WhiteLabelContentContainer title={'FAQ Content'}>
       <>
          <Row>
            <Col sm={12}>
              <Field
                name={'meta.whitelabel.faq.enabled'}
                component={PublicCheckbox}
                label={'Enabled'}
              />
            </Col>
          </Row>
          <ContentFields isEnabled={isEnabled} template={template}/>
       </>
      </WhiteLabelContentContainer>
  );
};
export default Faqs;
